<template>
  <div>
    <template v-if="!getTextModel">
      <el-date-picker
        v-bind="item"
        v-model="form[item.bind]"
        :type="item.timeType ? item.timeType : 'datetime'"
        :format="item.format ? item.format : 'yyyy-MM-dd HH:mm:ss'"
        :value-format="item.format ? item.format : 'yyyy-MM-dd HH:mm:ss'"
        @change="
          (val) => {
            item.change && item.change(val, item);
          }
        "
      ></el-date-picker>
    </template>
    <div v-else>
      {{ getTextContent }}
    </div>
  </div>
</template>

<script>
export default {
  name: "FormItemDateSelect",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    formComConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
    getTextContent() {
      let val = this.form[this.item.bind];
      let content = "";
      if (val) {
        if (Object.prototype.toString.call(val) === "[object String]") {
          content = val;
        } else if (Object.prototype.toString.call(val) === "[object Array]") {
          val.map((valItem, valIndex) => {
            if (valIndex == 0) {
              content += valItem;
            } else {
              content += " ~ " + valItem;
            }
          });
        }
      }
      return content;
    }
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// packages/SrAdd/components/form-item-date-select.vue